module.exports = __webpack_public_path__ + "img/Klaims.9bbbeadd.svg";